import { setActionableAlert, setAlertMode, setMessage, setShowAlert } from "./Alert/alert.slice"
import store from "./store"

export const showMessageOnFailure = (message: string) => {
    return () => {
        if (typeof message === 'string') {
            store.dispatch(setActionableAlert(false));
            store.dispatch(setAlertMode(false));
            store.dispatch(setMessage(message))
            store.dispatch(setShowAlert(true))
        }
    }
}